import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CaseService } from '../shared/services/case.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-off-hold',
  templateUrl: './off-hold.component.html',
  styleUrls: ['./off-hold.component.scss']
})
export class OffHoldComponent implements OnInit {

  @Input() caseId: number = 0;
  isLoading: boolean = false;

  offHoldDetails= new UntypedFormGroup({
    offHoldReason: new UntypedFormControl()
  });

   constructor(
    public activeModal: NgbActiveModal,
    private caseService: CaseService) {
  
    }

  ngOnInit(): void {
  }

  takeCaseOffHold(){

    this.isLoading = true;
    this.caseService.offHoldCase(this.caseId, this.offHoldDetails.value).subscribe(response => {

      this.activeModal.close(true);

      }, error => {

        var errorMessage = "Failed to take case off hold";
        if(error.error !== null && error.error.message !== undefined)
        {
          errorMessage = error.error.message;
        }

      });

  }

  cancel(){
    this.activeModal.dismiss();
  }
}
